import { TranslateUnauthenticatedPipe } from '../../../filters/translate-unauthenticated.pipe';
import { TranslatePipe } from '../../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../../utils/session.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import BusinessRestServices from '../../../services/business-rest.service';
import Config from '../../../utils/config.service';
import RoutingService from '../../../services/routing.service';
import AngularStateHelperService from '../../../services/angular-state-helper.service';
import AppLanguageService from '../../../services/app-language.service';

@Component({
	standalone: true,
	selector: 'benu-login-landing-page',
	templateUrl: './benu-login-landing-page.component.html',
	imports: [ CommonModule, TranslateUnauthenticatedPipe, TranslatePipe, FormsModule ]
})
export default class BenuLoginLandingPageComponentModule implements OnInit {
	private session: Session = inject(Session);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private config: Config = inject(Config);
	private routingService: RoutingService = inject(RoutingService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.businessRestServices.getBenuQrOnDemandSetting().then((benuSetting) => {
			this.vm.benuSetting = benuSetting;
			this.routingService.getSessionData().then(() => {
				var sessionData: any = this.angularStateHelperService.getGlobalProperty('session');
				this.vm.isAuthenticated = !!sessionData;
				if (this.vm.isAuthenticated) {
					this.routingService.validateAccess('booking').then(() => { }).catch(console.error);
				}
			}).catch(console.error);
			this.onResolve();
		}).catch(console.error);
	}
	
	onResolve() {
		var benu: any = "benu";
		window.sessionStorage.setItem("THIRD_PARTY_RENEWAL", benu);
		
		var origin: any = 'minudoc.ee';
		this.vm.locales = this.appLanguageService.getLanguagesByOrigin(origin);
		this.vm.language = window.navigator.language;
		this.vm.locale = window.sessionStorage.getItem("locale") || 'et_EE' ;
		this.vm.lang = window.sessionStorage.getItem("locale") || 'et_EE' ;
		
		if (this.angularRoutingHelperService.getQueryParam('LOC')) {
			window.sessionStorage.setItem("THIRD_PARTY_RENEWAL", benu);
			window.sessionStorage.setItem("LOC", this.angularRoutingHelperService.getQueryParam('LOC'));
			this.angularRoutingHelperService.setQueryParam('LOC', null);
		}
		
		this.vm.redirectToNextPage = this.redirectToNextPage;
		this.vm.reload = this.reload;
		this.vm.getLocaleOption = this.getLocaleOption;
		this.vm.toggleLangMenu = this.toggleLangMenu;
		this.vm.setLocale = this.setLocale;
	}
	
	redirectToNextPage() {
		var redirectLink: any = '/prescription-list';
		if (this.vm.isAuthenticated) {
			this.angularRoutingHelperService.setPathAndKeepQueryParams(redirectLink);
		} else {
			if (this.vm.lang === 'en_GB') {
				this.session.goToLogin('/login');
			} else if (this.vm.lang === 'ru_RU') {
				this.session.goToLogin('/vhod');
			} else {
				this.session.goToLogin();
			}
			window.sessionStorage.setItem("BENU_REDIRECT_AFTER_LOGIN", redirectLink);
		}
	}
	
	reload(event) {
		if (event && event.preventDefault) {
			event.preventDefault();
		}
		this.angularRoutingHelperService.clearQueryParamsDirty();
		var userSession = this.session.getSession() ? this.session.getSession().user : null;
		if (this.vm.activePath === this.angularRoutingHelperService.goHomeAndReturnPath(userSession)) {
			this.angularRoutingHelperService.reloadRoute();
		} else {
			this.angularRoutingHelperService.goHomeAndKeepHistory(userSession);
		}
	}
	
	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}
	
	toggleLangMenu(toOpen) {
		if (typeof toOpen === 'undefined') {
			toOpen = !this.vm.langOpen;
		}
		this.vm.langOpen = toOpen;
	}
	
	setLocale(locale) {
		if (this.vm.langDisabled) return;
		this.vm.langDisabled = true;
		
		this.vm.locale = locale;
		window.sessionStorage.setItem("locale", locale)
		window.location.reload();
	}
	
}
